export default __webpack_public_path__ + "static/fprimg-ac0f5f6913fca238c013b72a4e92a065.png";